import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Box, Flex, Icon, Text } from 'roo-ui/components';
import { Money } from 'types';
import { PendingScheduledPayment } from 'lib/bookingInfo';
import { toDisplayDateFormat } from 'lib/utils';
import { Title, Totals } from 'components/payments/primitives/BaseTotal/BaseTotal';
import getExcludePayableAtPropertyLabel, { PayableAtPropertyBreakdown } from '../helpers/getExcludePayableAtPropertyLabel';

export interface PaymentTotalProps {
  payableAtPropertyBreakdown?: PayableAtPropertyBreakdown;
  paidToDateAmounts: Array<Money>;
  pendingScheduledPayment?: PendingScheduledPayment;
}

const PaymentTotal = ({ payableAtPropertyBreakdown, paidToDateAmounts, pendingScheduledPayment, ...props }: PaymentTotalProps) => (
  <Flex justifyContent="space-between" alignItems="baseline" flexDirection="column" bg="ui.infoBackground" px={5} py={4} {...props}>
    <Flex justifyContent="space-between" width="100%" data-testid="total-paid-amount">
      <Box pr={5}>
        <Title>{`Total paid${!isEmpty(pendingScheduledPayment) ? ' to date' : ''}`}</Title>
      </Box>
      <Box flex="0 0 auto">
        <Totals totals={paidToDateAmounts} />
      </Box>
    </Flex>
    {pendingScheduledPayment && (
      <Flex justifyContent="space-between" width="100%" pt={4} data-testid="outstanding-amount">
        <Box pr={5}>
          <Title>
            <Icon name="accessTime" size={18} mb={1} mr={1} /> Pay later on {toDisplayDateFormat(pendingScheduledPayment.deferredTo)}
          </Title>
          <Text data-testid="final-payment" fontSize="sm" color="emperor" as="div">
            Final payment will be automatically charged to your{' '}
            {pendingScheduledPayment.creditCardPaymentAllocation.paymentMethod.cardType &&
              `${pendingScheduledPayment.creditCardPaymentAllocation.paymentMethod.cardType} `}
            credit card ending {pendingScheduledPayment.creditCardPaymentAllocation.paymentMethod.lastFourDigits}.
          </Text>
        </Box>
        <Box flex="0 0 auto">
          <Totals totals={[pendingScheduledPayment.total]} />
        </Box>
      </Flex>
    )}
    {!isEmpty(payableAtPropertyBreakdown) && (
      <Text fontSize="sm" color="emperor" as="div">
        {getExcludePayableAtPropertyLabel(payableAtPropertyBreakdown)}
      </Text>
    )}
  </Flex>
);

export default PaymentTotal;
